import script from "./importPointTable.vue?vue&type=script&setup=true&lang=js"
export * from "./importPointTable.vue?vue&type=script&setup=true&lang=js"

import "./importPointTable.vue?vue&type=style&index=0&id=62f463b2&lang=scss"

const __exports__ = script;

export default __exports__